import React from 'react'

export default () => (
    <footer className='footer'>
        <p>Made with <span role='img' aria-label='red heart'>♡</span> by Pankaj Meghani</p>
        <p><a href='https://darksky.net/poweredby/'>Powered by DarkSky</a></p>
        <p>Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></p>
    </footer>
)